import React, { useEffect, useMemo, useRef, useState } from 'react'
// Icons
import { ReactComponent as GalleryIcon } from './icons/gallery.svg'
import { ReactComponent as CloseIcon } from './icons/close.svg'
import { ReactComponent as CloseIconTransparent } from './icons/close-transparent.svg'
import Carousel from './components/Carousel'
import ContentIndicator from './components/ContentIndicator'
import useDetectDevice from '../../../../../hooks/useDetectDevice'
import { getCdnAssetUrl } from '../../../../../helpers/assets'
import Image from './components/Image'
import Loader from '../../../../Loader'
import { getLineAsFloorName } from '../../../../../helpers/line'

function OfficesGallery({ packages, selectedLine, selectedPackage }) {
  const [toggled, setToggled] = useState(false)
  const [activeSlide, setActiveSlide] = useState()
  const [carousel, setCarousel] = useState()
  const [loading, setLoading] = useState(true)
  const { isDesktop } = useDetectDevice()

  const slides = useMemo(() => {
    const packs = packages.map((p) => ({
      ...p,
      design_layouts: p.design_layouts.map((d) => ({
        ...d,
        photos: d.photos.map((photo) => ({ ...photo, package_id: p.id })),
      })),
    }))
    return packs
      .map((p) => p.design_layouts)
      .flat()
      .map((d) => d.photos)
      .flat()
      .map((photo, index) => ({
        index,
        package_id: photo.package_id,
        content: (
          <Image
            src={getCdnAssetUrl(photo.src)}
            onLoad={(e) => {
              index === 0 && setLoading(false)
            }}
          />
        ),
      }))
  }, [packages])

  const package_name = useMemo(() => {
    if (!activeSlide) {
      return
    }
    return packages.find((p) => p.id === activeSlide.package_id).display_name
  }, [activeSlide, packages])

  const closeBtn = <div className="h-[32px] flex items-center">
  <button
    onClick={() => {
      setToggled(false)
    }}
    type="button"
    className="h-[24px] w-[24px] bg-[#fff] lg:bg-[transparent] flex items-center justify-center rounded-full shadow-md lg:shadow-none"
  >
    <div className="lg:hidden">
      <CloseIcon />
    </div>
    <div className="hidden lg:block">
      <CloseIconTransparent />
    </div>
  </button>
</div>

  return (
    <>
      {slides.length > 0 && (
        <button
          type="button"
          onClick={() => {
            setToggled(true)
          }}
          className="bg-[#fff]  rounded-[6px] shadow-sm h-[40px] px-[12px] flex items-center justify-center max-w-[400px] "
        >
          <span className="text-[14px] font-medium mr-[12px]">Gallery</span>
          <div className="w-[1px] h-full bg-[#E5E7ED]"></div>
          <div className="ml-[12px]">
            <GalleryIcon />
          </div>
        </button>
      )}
      {toggled && (
        <div
          className="fixed portait:h-[calc(100dvh)] h-full w-full bg-black lg:bg-[rgba(0,0,0,.7)] backdrop-blur-[2px]  left-0 top-0  lg:!top-0 z-[100] flex justify-center items-center fade-in"
          onClick={() => {
            setToggled(false)
          }}
        >
          {loading && (
            <div className="fixed top-0 left-0 h-screen w-screen flex items-center justify-center">
              <div className="bg-white h-[180px] w-[180px] flex items-center justify-center rounded-xl">
                <Loader />
              </div>
            </div>
          )}

          <div
            className={`rounded-[8px]   relative ${loading ? 'opacity-0' : ''}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="fixed lg:absolute top-[22px] left-[24px] z-[10] flex items-center justify-between w-[calc(100%-48px)]">
              <div className="bg-[#fff] h-[40px] rounded-[6px] shadow-md px-[12px]  min-w-[100px] flex items-center justify-center lg:text-[14px] text-[#3D4256] font-medium ">
                <span className="hidden lg:inline-block">
                  {package_name}
                </span>
                <span className="lg:hidden">{package_name}</span>
              </div>
              {closeBtn}
            </div>
            

            <Carousel
              navigation={isDesktop}
              slidesPerView="auto"
              className="custom-navigation-slider aspect-[4/3] max-h-[calc(100dvh)] portrait:max-h-[80dvh] lg:!max-h-[80dvh] max-w-[90%] lg:max-w-[95dvw] overflow-hidden rounded-[8px] "
              spaceBetween={0}
              loop={true}
              initialSlide={slides.findIndex((s) => s.package_id === selectedPackage.id)}
              watchSlidesProgress={true}
              centeredSlides
              slideClassName="!w-auto !h-full !flex justify-center items-center"
              onSwiper={(swiper) => {
                setActiveSlide(slides[swiper.realIndex])
                setCarousel(swiper)
              }}
              observer={true}
              observeParents={true}
              observeSlideChildren={true}
              resizeObserver={true}
              onSlideChange={(swiper) => {
                setActiveSlide(slides[swiper.realIndex])
              }}
              items={slides.map((s) => s.content)}
            />
            <div className="absolute bottom-[16px] portrait:bottom-[-40px] lg:bottom-[24px] flex items-center justify-center w-full">
              {carousel && activeSlide && (
                <ContentIndicator activeSlide={activeSlide} carousel={carousel} slides={slides} />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default OfficesGallery
